import '../../../../external-libraries/highcharts/12.4.0/highcharts.js';
import '../../../../external-libraries/highcharts/12.4.0/modules/accessibility.js';

import DataVisualizationUtil from '../../dataVisualization/util.js';
import NeptuneElement from '../../NeptuneElement.js';

export class BarChart extends NeptuneElement {

    templateMarkup = `
      <figure alt="Bar chart"></figure>    
    `;

    componentCssUrl = '/src/components/dataVisualization/chart.css';

    #chartContainer;
    #chartData = '[]';
    #chartSettings = '{}';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.validateRequiredProperties(['series']);
        this.processInitialAttributesAfterRender(BarChart.observedAttributes);

        this.getChartColors = DataVisualizationUtil.getChartColors;
        this.normalizeSeriesData = DataVisualizationUtil.normalizeSeriesData;
        this.combineNamesWithSeries = DataVisualizationUtil.combineNamesWithSeries;
        this.#chartContainer = this.shadowRoot.querySelectorAll('figure')[0];
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return ['series', 'settings'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isRendered) {
            return;
        }
        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        switch (name) {
            case 'series': {
                if ('' === newValue) {
                    return;
                }
                this.#chartData = newValue;
                break;
            }
            case 'settings': {
                if ('' === newValue) {
                    return;
                }
                this.#chartSettings = newValue;
                break;
            }
            default: {
                break;
            }
        }
        this.#renderChart();
    }

    /*
     Use setTimeout to give Highcharts enough time to calculate the container geometry and render
     itself including labels correctly.
     */
    #renderChart() {
        setTimeout(() => {
            this.#drawChart(this.#chartContainer, JSON.parse(this.#chartData), JSON.parse(this.#chartSettings));
        }, 100);
    }

    #drawChart(id, seriesData, chartSettings) {
        if ((undefined == seriesData) || ([] == seriesData)) {
            console.log('Neptune Bar chart: No data');
            return;
        }

        if ((undefined == chartSettings) || ({} == chartSettings)) {
            chartSettings = {};
        }

        seriesData = this.normalizeSeriesData(seriesData);

        if (undefined != chartSettings?.seriesNames) {
            seriesData = this.combineNamesWithSeries(chartSettings.seriesNames, seriesData);
        }

        // eslint-disable-next-line
        return Highcharts.chart(id, {
            chart: {
                type: 'column'
            },
            colors: this.getChartColors(),
            title: {
                text: chartSettings?.title ?? ''
            },
            subtitle: {
                text: chartSettings?.subtitle ?? ''
            },
            xAxis: {
                categories: chartSettings?.categories,
                crosshair: true
            },
            yAxis: {
                title: {
                    text: chartSettings.yAxisTitle ?? ''
                }
            },
            tooltip: {
                enabled: true
            },
            plotOptions: {
                series: {
                    name: '',
                    colorByPoint: true,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.1f}'
                    },
                    label: {
                        enabled: false
                    }
                }
            },
            legend: {
                enabled: chartSettings.showLegend ?? false
            },
            series: seriesData
        });
    }
}


customElements.define('neptune-bar-chart', BarChart);

export default { BarChart };